<template>
  <div>
    <div class="p404 bg-cercles">
      <div v-if="doing">
        <p>
          {{ $t("converttowishlist.processing") }}
        </p>
      </div>
      <div v-else class="p404__content">
        <h2 class="p404__title">{{ $t("converttowishlist.success") }}</h2>
        <p>
          {{ $t("converttowishlist.successDescription") }}
        </p>
        <button
          @click="$router.push({ name: 'owner-list' })"
          class="button button--primary button--block"
        >
          {{ $t("converttowishlist.successButton") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "ConvertToWishlist",
  metaInfo() {
    return {
      title: "Convert To Wishlist" + " | HelloBB",
      meta: [
        { name: "description", content: "Convert your list to a wishlist easily." },
        { name: "robots", content: "noindex"},
      ]
    };
  },
  data() {
    return {
      doing: true,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      isApp: "isApp"
    }),
  },
  methods: {
    setLanguage() {
      if (typeof window === "undefined") return;
      if(this.isAuthenticated) return;
      let langUrl = new URLSearchParams(window.location.search).get("lang") || "es";
      //get first two letters
      langUrl = langUrl.substring(0, 2).toLowerCase();
      if(langUrl == "fr") {
        this.lang = "fr-FR";
      } else if(langUrl == "it") {
        this.lang = "it-IT";
      }
      else if(langUrl == "en") {
        this.lang = "en-GB";
      }
      else {
        this.lang = "es";
      }
      this.$i18n.locale = this.lang;
    }
  },
  mounted() {
    this.setLanguage();
    //get from query param the listId
    const urlParams = new URLSearchParams(window.location.search);
    const listId = urlParams.get('listid');
    //timer to simulate conversion
    setTimeout(() => {
      this.$store.dispatch('convertToWishlist', { listId: listId })
      .then(() => {
        return this.$store.dispatch('updateUserDefaultListId', Number(listId));
      })
      .then(() => {
        this.doing = false;
      })
    }, 3000);
  }
};
</script>

<style scoped>
p {
  font-size: 1.2rem;
  line-height: 1.5;
  max-width: 60%; /* O el ancho máximo que prefieras */
  margin: 0 auto; /* Esto centra el contenedor horizontalmente */
}

@media (max-width: 768px) {
  p {
    font-size: 1rem; /* Tamaño de fuente más pequeño para móviles */
    line-height: 1.4; /* Ajuste del interlineado para mejorar la legibilidad en pantallas pequeñas */
    max-width: 90%;
  }
}
</style>
